import classNames from "classnames";
import { ReactNode } from "react";

import styles from "./HeroFull.module.css";

const Hero: React.FC<HeroProps> = ({
  image,
  title,
  subtitle,
  claim,
  className,
}) => (
  <div className={classNames(styles.hero, className)}>
    {image && <div className={styles.image}>{image}</div>}
    <div className={styles.content}>
      <div className={classNames("grid", styles.contentText)}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {claim && <p className={styles.claim}>{claim}</p>}
      </div>
    </div>
  </div>
);

type HeroProps = {
  image: ReactNode;
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  claim?: string | ReactNode;
  className?: string;
};

export const imageSizes = "100vw";

export default Hero;
